import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Punjab = () => {
  return (
    <div className="bg-white">

       <Helmet>
        <title>Best School ERP Software in Punjab | Gurukul ERP</title>
        <meta
          name="description"
          content="Top School ERP Software in Punjab for schools in Ludhiana, Amritsar, Jalandhar & Patiala. Automate fees, exams, attendance & academic processes."
        />
        <meta
          name="keywords"
          content="School ERP software Punjab, School Management System Ludhiana, CBSE school ERP Amritsar, School software Jalandhar"
        />
        <link
          rel="canonical"
          href="https://www.gurukulerp.in/punjab"
        />
      </Helmet>

      {/* HERO */}
      <section className="py-20 bg-gradient-to-r from-[#0c5a87] to-[#0a4a6d] text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-2 gap-12 items-center">

          <div>
            <h1 className="text-3xl md:text-5xl font-bold mb-6 leading-tight">
              Best School ERP Software in Punjab
            </h1>

            <p className="text-gray-200 mb-4">
              Gurukul ERP provides advanced cloud-based School ERP Software
              designed for schools, colleges, and coaching institutes across Punjab.
            </p>

            <p className="text-gray-200 mb-6">
              Serving institutions in Ludhiana, Amritsar, Jalandhar,
              Patiala, Mohali, Bathinda, Hoshiarpur, and Pathankot.
            </p>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/contact"
                className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-full font-medium transition"
              >
                Request Free Demo
              </Link>

              <Link
                to="/"
                className="border border-white px-6 py-3 rounded-full hover:bg-white hover:text-[#0c5a87] transition"
              >
                Explore Features
              </Link>
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src="/herosectionhr.png"
              alt="School ERP Software Punjab"
              className="w-full max-w-[550px] rounded-xl shadow-2xl"
            />
          </div>

        </div>
      </section>


      {/* ABOUT */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-[#0c5a87] mb-6">
            Complete Digital School Management Solution in Punjab
          </h2>

          <p className="text-gray-600 max-w-4xl mx-auto">
            Our School ERP system helps automate academic processes, fee
            collection, examination management, student records, and HR
            operations. Schools across Punjab are rapidly adopting digital
            systems to improve efficiency, transparency, and streamlined
            administrative management.
          </p>
        </div>
      </section>


      {/* UNIQUE FEATURES SECTION */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">

          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#0c5a87] mb-4">
            Advanced Features of Our Punjab School ERP
          </h2>

          <p className="text-center text-gray-600 max-w-3xl mx-auto mb-16">
            Our comprehensive ERP system is designed to streamline every department
            of your school — from academics to administration — through intelligent automation.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">

            {[
              {
                title: "Admin Dashboard",
                desc: "Centralized control panel to manage students, staff, fees, reports, and overall school operations."
              },
              {
                title: "Teacher Panel",
                desc: "Teachers can manage attendance, upload assignments, share study material, and publish results."
              },
              {
                title: "Student Panel",
                desc: "Students can access homework, assignments, test results, academic progress, and announcements."
              },
              {
                title: "Mobile Application",
                desc: "Dedicated mobile access for instant updates, notifications, and academic tracking anytime."
              },
              {
                title: "Course Material Management",
                desc: "Upload and organize syllabus, notes, PDFs, videos, and learning resources in one place."
              },
              {
                title: "Online Tests & Exams",
                desc: "Create online exams, auto-generate results, and analyze student performance instantly."
              },
              {
                title: "Assignment Management",
                desc: "Assign homework digitally, track submissions, and evaluate performance efficiently."
              },
              {
                title: "Attendance Automation",
                desc: "Real-time attendance tracking with daily, monthly, and yearly reporting."
              },
              {
                title: "Fee & Finance Management",
                desc: "Automated fee collection, online payment integration, and financial reporting."
              }
            ].map((feature, index) => (
              <div
                key={index}
                className="group bg-white p-8 rounded-2xl shadow-md hover:shadow-2xl transition duration-500 border border-gray-100 relative overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-24 h-24 bg-orange-100 rounded-full group-hover:scale-150 transition duration-500"></div>

                <div className="w-14 h-14 flex items-center justify-center bg-[#0c5a87] text-white rounded-full mb-5 text-xl font-bold shadow-md relative z-10">
                  {index + 1}
                </div>

                <h3 className="text-lg font-semibold text-[#0c5a87] mb-3 relative z-10">
                  {feature.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed relative z-10">
                  {feature.desc}
                </p>
              </div>
            ))}

          </div>

        </div>
      </section>


      {/* BENEFITS */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">

          <div>
            <img
              src="/ChatGPT Image Feb 28, 2026, 05_03_03 PM.png"
              alt="School ERP Software Punjab"
              className="rounded-xl shadow-lg"
            />
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-[#0c5a87] mb-6">
              Benefits for Schools in Punjab
            </h2>

            <ul className="space-y-4 text-gray-600">
              <li>✔ Reduce administrative workload significantly</li>
              <li>✔ Improve data accuracy and transparency</li>
              <li>✔ Secure cloud-based data storage</li>
              <li>✔ Real-time academic performance tracking</li>
            </ul>

          </div>

        </div>
      </section>


      {/* PROCESS */}
      <section className="py-20 bg-[#f4f7fb]">
        <div className="max-w-6xl mx-auto px-6 text-center">

          <h2 className="text-3xl font-semibold text-[#0c5a87] mb-12">
            Our Implementation Process
          </h2>

          <div className="grid md:grid-cols-4 gap-8">

            {[
              "Requirement Analysis",
              "System Setup",
              "Training & Onboarding",
              "Go Live Support"
            ].map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md">
                <div className="text-2xl font-bold text-orange-500 mb-3">
                  0{index + 1}
                </div>
                <h3 className="font-semibold text-[#0c5a87] mb-2">
                  {step}
                </h3>
                <p className="text-sm text-gray-600">
                  Structured and smooth ERP implementation for institutions.
                </p>
              </div>
            ))}

          </div>
        </div>
      </section>


      {/* FINAL CTA */}
      <section className="py-20 bg-[#0c5a87] text-white text-center">
        <div className="max-w-4xl mx-auto px-6">

          <h2 className="text-3xl font-semibold mb-4">
            Ready to Digitize Your School in Punjab?
          </h2>

          <p className="mb-6">
            Upgrade your institution with a secure and scalable School ERP solution.
          </p>

          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 transition px-8 py-3 rounded-full font-medium"
          >
            Get Free Consultation
          </Link>

        </div>
      </section>

    </div>
  );
};

export default Punjab;